import { buildInstalledBasePathname } from './installedBaseUrl';

export interface BreadcrumbPathNode {
    id: string;
    nodeType?: { key?: string | null } | null;
    assetLocation?: { id?: string | null } | null;
    system?: { id?: string | null } | null;
}

// Link target of an ancestor crumb on the asset/system detail views: ASSET and
// SYSTEM ancestors (e.g. the parent of a sub-asset) open their dashboards;
// every other node type — and ASSET/SYSTEM nodes whose relation is missing —
// opens the Installed Base tree at that node. `pathIds` is the root → node id
// path including the node itself.
export const getBreadcrumbPathNodeLink = (node: BreadcrumbPathNode, pathIds: string[]): string => {
    if (node.nodeType?.key === 'ASSET' && node.assetLocation?.id) {
        return `/assets/${node.assetLocation.id}/dashboard`;
    }
    if (node.nodeType?.key === 'SYSTEM' && node.system?.id) {
        return `/systems/${node.system.id}/dashboard`;
    }
    return buildInstalledBasePathname([null, ...pathIds]);
};
